import $ from "jquery";

const header = (smoothScroll) => {
  const togglerMobileMenu = $(".navbar-toggler");
  const mobileMenu = $(".header__nav-mobile");

  function toggleMobileMenu() {
    togglerMobileMenu.on("click", function () {
      if ($(this).hasClass("close-menu")) {
        mobileMenu.removeClass("open-mobile-menu");
        togglerMobileMenu.removeClass("close-menu");
        smoothScroll.start();
      } else {
        mobileMenu.addClass("open-mobile-menu");
        togglerMobileMenu.addClass("close-menu");
        smoothScroll.stop();
      }
    });
  }

  function closeMenu() {
    $(document).on("click", function (e) {
      if (
        $(window).width() < 1024 &&
        $(mobileMenu).hasClass("open-mobile-menu")
      ) {
        if (
          e.target.closest(".nav-mobile") === null &&
          e.target.closest(".navbar-toggler") === null
        ) {
          mobileMenu.removeClass("open-mobile-menu");
          togglerMobileMenu.removeClass("close-menu");
          smoothScroll.start();
        }
      }
    });
  }

  function closeMenuOnResize() {
    (function () {
      $(window).on("resize", function () {
        if (
          $(window).width() < 1024 &&
          $(mobileMenu).hasClass("open-mobile-menu")
        ) {
          mobileMenu.removeClass("open-mobile-menu");
          togglerMobileMenu.removeClass("close-menu");
          $(".lang-switcher__dropdown.show").removeClass("show");
          $(".lang-switcher__current-lang.active").removeClass("active");
          smoothScroll.start();
        }
      });
    })();
  }

  function headerLogoHover() {
    const logo = $(".header-logo");
    let hoverTimeout;

    logo.on("mouseenter", function () {
      const $this = $(this);

      $this.addClass("h-hover");
      clearTimeout(hoverTimeout);

      hoverTimeout = setTimeout(() => {
        $this.removeClass("h-hover");
      }, 1500);
    });
  }

  return {
    init() {
      toggleMobileMenu();
      closeMenu();
      closeMenuOnResize();
      headerLogoHover();
    },
  };
};

export { header };
